import { PLATFORMS } from './constants';

// The subscriptions hired through the Tray/Bagy app install are billed by the platform
// itself, together with the store's invoice, and were created with synthetic IDs prefixed
// with the platform (e.g. tray_882922_1703055105224). The ones hired with us are billed
// by Iugu and use the ID generated by Iugu.
const platformBilledSubscriptionIdPrefixes = [
    `${PLATFORMS.TRAY}_`,
    `${PLATFORMS.BAGY}_`
];

export const isBilledByTrayCompatiblePlatform = subscription => {
    const subscriptionId = subscription?.id || '';

    return platformBilledSubscriptionIdPrefixes.some(prefix => subscriptionId.startsWith(prefix));
}
